import React from 'react';
import { Button, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Breadcrumb from '../../../layouts/full/shared/breadcrumb/Breadcrumb';

import PageContainer from '../../../components/container/PageContainer';
import BlankCard from 'src/components/shared/BlankCard';

import RegisterCard from 'src/components/management/email-schedules/email-schedule-add/EmailScheduleRegisterForm';

const BCrumb = [
  {
    to: '/',
    title: 'Home',
  },
  {
    title: 'Email Schedule Management',
  },
];
const AddEmailSchedule = () => {
  return (
    <PageContainer title="Email Schedule Management" description="this is Email Schedule Management page">
      {/* breadcrumb */}
      <Breadcrumb title="Email Schedule Management" items={BCrumb} />
        <Grid container spacing={3}>
          <Grid size={{ lg: 12 }}>
            <Stack spacing={3}>
              <BlankCard>
                <RegisterCard />
              </BlankCard>
            </Stack>
          </Grid>
        </Grid>
    </PageContainer>
  );
};

export default AddEmailSchedule;
